// extracted by mini-css-extract-plugin
export default {"component":"styles_component__cAAr0","loadingMsg":"styles_loadingMsg__s9b68","loaderChord":"styles_loaderChord__51Usu"};